import axios from 'axios'
import { AXIOS_DEFAULT_CONFIG, AXIOS_SECOND_CONFIG, AXIOS_LOCATION_CONFIG, AXIOS_RUIXUN_CONFIG } from '../config/config'
import { requestSuccessFunc, requestFailFunc, responseSuccessFunc, responseFailFunc } from '../config/index'
// let addressRequest = null
let axiosInstanceList = []
let axiosloc = axios.create(Object.assign({}, AXIOS_LOCATION_CONFIG, AXIOS_SECOND_CONFIG))
for (let i = 0; i < 2; ++i) {
  let axiosInstance
  if (i === 0) {
    axiosInstance = axios.create(AXIOS_DEFAULT_CONFIG)
    axios.defaults.baseURL = AXIOS_DEFAULT_CONFIG.baseURL
    if (process.env.NODE_ENV === 'production') {
      axios.defaults.baseURL = ''
      axiosloc.defaults.baseURL = ''
    }
  } else {
    axiosInstance = axios.create(Object.assign({}, AXIOS_DEFAULT_CONFIG, AXIOS_SECOND_CONFIG))
  }

// 注入请求拦截
  axiosInstance.interceptors.request.use(requestSuccessFunc, requestFailFunc)
// 注入失败拦截
  axiosInstance.interceptors.response.use(responseSuccessFunc, responseFailFunc)

  axiosInstanceList.push(axiosInstance)
}
axiosInstanceList.push(axiosloc)

axiosInstanceList.push(axios.create(Object.assign({}, AXIOS_DEFAULT_CONFIG, AXIOS_RUIXUN_CONFIG)))
if (process.env.NODE_ENV === 'production') {
  axiosInstanceList[3].defaults.baseURL = ''
}


const $https = {
  /**
   * 设置websocket地址 'ws://'开头
   * @param {String} url
   */
  setWebsocketUrl: function (url) {
    let host = 'ws://' + axios.defaults.baseURL.split('//')[1] + url
    return host
  },
  /**
   * 封装get方法
   * @param {String} url
   * @param {Object} params
   * @param {Boolean} loading
   * @param {Number} serverType
   * @returns {Promise}
   */
  get: function (url, params = {}, loading = true, serverType = 0) {
    return this.setAddress(() => axiosInstanceList[serverType].get(url, {
      params: params,
      loading
    }))
  },
  /**
   * 封装post请求
   * @param {String} url
   * @param {Object} data
   * @param {Object} params
   * @param {Boolean} loading
   * @param {Number} serverType
   * @returns {Promise}
   */
  post: function (url, data = {}, params = {}, loading = true, serverType = 0) {
    return this.setAddress(() => axiosInstanceList[serverType]({
      method: 'post',
      url: url,
      data,
      params,
      loading
    }))
  },
  /**
   * 封装delete请求
   * @param {String} url
   * @param {Object} data
   * @param {Boolean} loading
   * @param {Number} serverType
   * @returns {Promise}
   */
  delete: function (url, data = {}, loading = true, serverType = 0) {
    return this.setAddress(() => axiosInstanceList[serverType]({
      method: 'delete',
      url: url,
      data,
      loading
    }))
  },
  /**
   * 封装patch请求
   * @param {String} url
   * @param {Object} data
   * @param {Boolean} loading
   * @param {Number} serverType
   * @returns {Promise}
   */
  patch: function patch (url, data = {}, loading = true, serverType = 0) {
    return this.setAddress(() => axiosInstanceList[serverType]({
      method: 'patch',
      url: url,
      data,
      loading
    }))
  },
  /**
   * 封装put请求
   * @param {String} url
   * @param {Object} data
   * @param {Boolean} loading
   * @param {Number} serverType
   * @returns {Promise}
   */
  put: function (url, data = {}, loading = true, serverType = 0) {
    return this.setAddress(() => axiosInstanceList[serverType]({
      method: 'put',
      url: url,
      data,
      loading
    }))
  },
  /**
   * 设置baseURL
   * @param {function} proms
   * @returns {Promise}
   */
  setAddress: function (proms = () => {}) {
    let result = null
    if (process.env.NODE_ENV === 'production' && !axios.defaults.baseURL) {
      // if (!addressRequest) {
      //   addressRequest = axios.get('/static/address.json')
      // }
      // result = addressRequest.then(({ data: { data } }) => {
      //   if (!axios.defaults.baseURL) {
      //     axiosInstanceList[0].defaults.baseURL = data.baseURL
      //     axiosInstanceList[1].defaults.baseURL = data.secondURL
      //     axiosInstanceList[2].defaults.baseURL = data.locationURL
      //     axiosInstanceList[3].defaults.baseURL = data.ruixunURL
      //     axios.defaults.baseURL = data.baseURL
      //     sessionStorage.setItem('codeURL', data.codeURL)
      //     sessionStorage.setItem('locationURL', data.locationURL)
      //   }
      //   return proms()
      // })

      // 变量替换
      if (!axios.defaults.baseURL) {
        let data = {...window.ENV}
        axiosInstanceList[0].defaults.baseURL = data.baseURL
        axiosInstanceList[1].defaults.baseURL = data.secondURL
        axiosInstanceList[2].defaults.baseURL = data.locationURL
        axiosInstanceList[3].defaults.baseURL = data.ruixunURL
        axios.defaults.baseURL = data.baseURL
        sessionStorage.setItem('codeURL', data.codeURL)
        sessionStorage.setItem('locationURL', data.locationURL)
      }
      result = proms()
    } else {
      sessionStorage.setItem('locationURL', AXIOS_LOCATION_CONFIG.baseURL)
      result = proms()
    }
    return result
  },
  generateCancelTokenSource () {
    return axios.CancelToken.source()
  },
  isCancel (thrown) {
    return axios.isCancel(thrown)
  },
  // codeHandleList 为{code: xxx, type: xxx}的对象数组，code表示需要处理的代号，type表示处理手法。
  //   当code: all，代表所有代号。！！！！！注意，按照列表顺序，all前面的代号可以按指定type处理，all后面的代码会被忽略，因为都被all覆盖了
  //   当type: 0，默认处理形式（暂时只做了消息形错误提示，然后错误会流到逻辑层处理）；当type: 1，网络层不处理交由逻辑层处理；
  axios (config) {
    let serverType = config.serverType ? config.serverType : 0
    return this.setAddress(() => axiosInstanceList[serverType](Object.assign({
      loading: false,
      codeHandleList: [],
      errorOnCatch: true,
      isNewApi: false
    }, config)))
  },
  request (config) {
    return $https.axios({ ...config, isNewApi: true })
  },
  $axios: axiosInstanceList[0],
  axiosInstanceList
}

export default $https



// WEBPACK FOOTER //
// ./src/plugins/axios.js